import { useState } from "react";
import { useProfileStore } from "../store/profileStore";

export const useDeleteDoc = (): {
  deleteDoc: (formId: string) => Promise<boolean>;
  isDeleting: boolean;
  error: string | null;
} => {
  const deleteDocument = useProfileStore((state) => state.deleteDocument);
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDeleteDoc = async (formId: string): Promise<boolean> => {
    setIsDeleting(true);
    setError(null);
    try {
      await deleteDocument(formId);
      return true;
    } catch (err) {
      console.error("Failed to delete document:", err);
      setError("Failed to delete document");
      return false;
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    deleteDoc: handleDeleteDoc,
    isDeleting,
    error,
  };
};
